import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { FileTextOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import AntdTab from 'components/Tab/antd-tab';
import { parseHtml } from 'helpers/index';
import styles from 'styles/Unit.module.scss';
import QuestionList from './QuestionList';
import { useUnit } from 'hooks/units/index';
import { UNIT_STATUS } from 'constants/constants';
import ButtonCompleted from '../Complete/ButtonCompleted';
import ThemeButton from 'components/AntdFormInputs/theme-button';
import AttemptTable from './AttemptTable';
import TrackingResultAdaptive from './TrackingResultAdaptive';

const UNIT_STATUSES_OPEN_QUESTIONS_TAB = [
  UNIT_STATUS.FAILED,
  UNIT_STATUS.COMPLETED,
  UNIT_STATUS.PENDING,
];

const AdaptiveComplete = ({ tabBarExtra, className }) => {
  const [activeKey, setActiveKey] = useState('content');
  const unitSelected = useUnit();

  const contentData = unitSelected?.content;

  useEffect(() => {
    const status = unitSelected?.status;
    if (status && UNIT_STATUSES_OPEN_QUESTIONS_TAB.includes(status)) {
      setActiveKey('questions');
    }
  }, [unitSelected?.status]);

  if (
    unitSelected?.status === UNIT_STATUS.COMPLETED ||
    unitSelected?.status === 'INCOMPLETED'
  ) {
    return (
      <div className="adaptive-submit-outcome p-1 w-100">
        {parseHtml(contentData)}

        <div className="mt-4 w-100">
          <TrackingResultAdaptive unitId={unitSelected?._id} />
        </div>
      </div>
    );
  }

  return (
    <AntdTab
      activeKey={activeKey}
      onChange={setActiveKey}
      {...(tabBarExtra != null ? { tabBarExtraContent: tabBarExtra } : {})}
    >
      {({ TabPane }) => (
        <>
          <TabPane
            tab={
              <span className="d-flex align-items-center">
                <FileTextOutlined className="mr-05" />
                Content
              </span>
            }
            key="content"
          >
            <div
              className={classNames(
                'overflow-auto modal-body',
                styles.iframe_w_full,
              )}
            >
              {parseHtml(contentData)}
            </div>
          </TabPane>
          <TabPane
            tab={
              <span className="d-flex align-items-center">
                <QuestionCircleOutlined className="mr-05" />
                Questions
              </span>
            }
            key="questions"
          >
            <QuestionList
              unitId={unitSelected?._id}
              totalQuestions={unitSelected?.adaptiveSetup?.input?.questionCount}
              unitStatus={unitSelected?.status}
              microLearningContent={unitSelected?.microLearningContent}
            />
          </TabPane>
        </>
      )}
    </AntdTab>
  );
};

export default AdaptiveComplete;
